import { StoreTypeEnum } from "@/types/product";
import { createContext } from "react";

interface WarehouseContextType {
  id: string;
  type: StoreTypeEnum;
  categoryName: string;
}

const defaultContextValue: WarehouseContextType = {
  id: '',
  type: StoreTypeEnum.CODE,
  categoryName: ''
};

export const WarehouseContext = createContext(defaultContextValue);
